import mitt from "mitt";

type RtcEvents = {
  connectionEvent: "connected-cloud" | "connected-local" | "disconnected" | "connecting";
};

const rtcEmitter = mitt<RtcEvents>();

export { rtcEmitter, RtcEvents };
export default rtcEmitter;
